import React, { useState, useEffect } from "react";
import { endPoints } from "../../constant/Environment";
import { addData, deleteData, getAllData } from "../../Utility/API";
import { Modal, Form, Button } from "react-bootstrap";
import Toaster from "../../components/Toast";
import Loader from "../../components/Loader";
import PageHeader from "../../components/PageHeader";
import { ErrorToast, SuccesToast } from "../../components/Toast/message";
import DeleteModel from "../../components/DeleteModel";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import IconButton from "@mui/material/IconButton";
import FirstPageIcon from "@mui/icons-material/FirstPage";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import LastPageIcon from "@mui/icons-material/LastPage";
import { useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import TableFooter from "@mui/material/TableFooter";
import TablePagination from "@mui/material/TablePagination";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import VisibilityIcon from "@mui/icons-material/Visibility";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";
import Chip from "@mui/material/Chip";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import ListItemText from "@mui/material/ListItemText";
import OutlinedInput from "@mui/material/OutlinedInput";
import Checkbox from "@mui/material/Checkbox";

function TablePaginationActions(props) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => onPageChange(event, 0);
  const handleBackButtonClick = (event) => onPageChange(event, page - 1);
  const handleNextButtonClick = (event) => onPageChange(event, page + 1);
  const handleLastPageButtonClick = (event) =>
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));

  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton onClick={handleFirstPageButtonClick} disabled={page === 0} aria-label="first page">
        {theme.direction === "rtl" ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton onClick={handleBackButtonClick} disabled={page === 0} aria-label="previous page">
        {theme.direction === "rtl" ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === "rtl" ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === "rtl" ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </Box>
  );
}

const EMPTY_FORM = {
  title: "",
  multiplier: "",
  startTime: "18:00",
  eventDate: "",
  durationMinutes: "",
  coinMultiplier: "",
  streakMultiplier: "",
  bonusDrop: "",
  cashDrop: "",
  minPackage: "",
  teaserLeadMinutes: "",
  recapWindowMinutes: "",
  specifications: "",
  termsAndConditions: "",
  exclude_player: [],
  promotions: [],
  promotionMultipliers: {}, // { [promotionId]: coinMultiplier }
  isActive: 1,
};

// Languages the platform serves. English is the base text on the main form;
// the rest are stored as translation rows and fall back to English when blank.
const LANGUAGES = [
  { code: "en", name: "English", flag: "🇺🇸" },
  { code: "es", name: "Español", flag: "🇪🇸" },
  { code: "pt", name: "Português", flag: "🇧🇷" },
  { code: "it", name: "Italiano", flag: "🇮🇹" },
];
const LANGS = LANGUAGES.filter((l) => l.code !== "en");

const emptyTranslations = () =>
  LANGS.reduce((acc, l) => {
    acc[l.code] = { title: "", specifications: "", termsAndConditions: "" };
    return acc;
  }, {});

const HappyHour = () => {
  const [rows, setRows] = useState([]);
  const [playerTypes, setPlayerTypes] = useState([]);
  const [promotions, setPromotions] = useState([]); // active configurations
  const [isLoading, setIsLoading] = useState(false);

  const [editData, setEditData] = useState({});
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);

  const [viewData, setViewData] = useState(null);
  const [showView, setShowView] = useState(false);

  const [rowDataToDelete, setRowDataToDelete] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);

  const [form, setForm] = useState(EMPTY_FORM);
  const [translations, setTranslations] = useState(emptyTranslations());
  const [showTranslations, setShowTranslations] = useState(false);

  const setTranslationField = (lang, key, value) =>
    setTranslations((prev) => ({
      ...prev,
      [lang]: { ...prev[lang], [key]: value },
    }));

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [filterValue, setFilterValue] = useState("");

  useEffect(() => {
    fetchHappyHours();
    fetchPlayerTypes();
    fetchPromotions();
  }, []);

  // Hydrate the form whenever an existing row is selected for edit.
  useEffect(() => {
    if (editData && editData.id) {
      setForm({
        title: editData.title || "",
        multiplier: editData.multiplier ?? "",
        startTime: (editData.startTime || "18:00").slice(0, 5),
        eventDate: editData.eventDate || "",
        durationMinutes: editData.durationMinutes ?? "",
        coinMultiplier: editData.coinMultiplier ?? "",
        streakMultiplier: editData.streakMultiplier ?? "",
        bonusDrop: editData.bonusDrop ?? "",
        cashDrop: editData.cashDrop ?? "",
        minPackage: editData.minPackage ?? "",
        teaserLeadMinutes: editData.teaserLeadMinutes ?? "",
        recapWindowMinutes: editData.recapWindowMinutes ?? "",
        specifications: editData.specifications || "",
        termsAndConditions: editData.termsAndConditions || "",
        exclude_player: Array.isArray(editData.exclude_player)
          ? editData.exclude_player
          : [],
        promotions: Array.isArray(editData.promotions)
          ? editData.promotions.map((p) => (typeof p === "object" ? p.id : p))
          : [],
        promotionMultipliers: Array.isArray(editData.promotions)
          ? editData.promotions.reduce((acc, p) => {
              if (p && typeof p === "object")
                acc[p.id] = p.coinMultiplier ?? p.multiplier ?? "";
              return acc;
            }, {})
          : {},
        isActive: editData.isActive ?? 1,
      });
      fetchTranslations(editData.id);
    } else {
      setForm(EMPTY_FORM);
      setTranslations(emptyTranslations());
    }
  }, [editData]);

  // Load the stored per-language rows into the edit form.
  const fetchTranslations = async (id) => {
    setTranslations(emptyTranslations());
    try {
      const response = await getAllData(`${endPoints.api.GET_HAPPY_HOUR_TRANSLATIONS}${id}`);
      if (response?.status === "success") {
        const next = emptyTranslations();
        (response.data || []).forEach((t) => {
          const code = String(t.language_code || "").toLowerCase();
          if (next[code]) {
            next[code] = {
              title: t.title || "",
              specifications: t.specifications || "",
              termsAndConditions: t.termsAndConditions || "",
            };
          }
        });
        setTranslations(next);
      }
    } catch (e) {
      console.error("translations fetch failed", e);
    }
  };

  const fetchHappyHours = async () => {
    setIsLoading(true);
    await getAllData(`${endPoints.api.GET_HAPPY_HOURS}`)
      .then((response) => {
        setIsLoading(false);
        const data = Array.isArray(response) ? response : response?.data || [];
        setRows(data);
      })
      .catch((error) => {
        setIsLoading(false);
        console.error(error);
      });
  };

  const fetchPlayerTypes = async () => {
    try {
      const response = await getAllData(`${endPoints.api.playertypes}`);
      const { status, data } = response || {};
      if (status === "success") setPlayerTypes(data || []);
    } catch (error) {
      console.error(error);
    }
  };

  const fetchPromotions = async () => {
    try {
      const response = await getAllData(`${endPoints.api.CONFIGURATION}`);
      const arr = Array.isArray(response) ? response : response?.data || [];
      // Only active configurations are offered as promotions.
      setPromotions(arr.filter((c) => c.isActive === true));
    } catch (error) {
      console.error(error);
    }
  };

  const setField = (key, value) => setForm((prev) => ({ ...prev, [key]: value }));

  const toNumberOrNull = (v) =>
    v === "" || v === null || v === undefined ? null : Number(v);

  const handleOk = () => {
    if (!form.title || !form.startTime || !form.durationMinutes) {
      ErrorToast("Title, start time and duration are required");
      return;
    }

    const url = editData?.id
      ? `${endPoints.api.UPDATE_HAPPY_HOUR}`
      : `${endPoints.api.ADD_HAPPY_HOUR}`;

    const payload = {
      title: form.title,
      multiplier: toNumberOrNull(form.multiplier),
      startTime: form.startTime,
      eventDate: form.eventDate || null,
      durationMinutes: toNumberOrNull(form.durationMinutes),
      coinMultiplier: toNumberOrNull(form.coinMultiplier),
      streakMultiplier: toNumberOrNull(form.streakMultiplier),
      bonusDrop: toNumberOrNull(form.bonusDrop),
      cashDrop: toNumberOrNull(form.cashDrop),
      minPackage: toNumberOrNull(form.minPackage),
      teaserLeadMinutes: toNumberOrNull(form.teaserLeadMinutes),
      recapWindowMinutes: toNumberOrNull(form.recapWindowMinutes),
      specifications: form.specifications,
      termsAndConditions: form.termsAndConditions,
      exclude_player: form.exclude_player,
      // Each selected promotion carries its own coin multiplier.
      promotions: form.promotions.map((id) => ({
        id,
        coinMultiplier: toNumberOrNull(form.promotionMultipliers?.[id]),
      })),
      isActive: Number(form.isActive),
      // Only languages with at least one field filled in are sent; the API upserts them.
      translations: LANGS.map((l) => ({
        language_code: l.code,
        title: translations[l.code]?.title || "",
        specifications: translations[l.code]?.specifications || "",
        termsAndConditions: translations[l.code]?.termsAndConditions || "",
      })).filter((t) => t.title || t.specifications || t.termsAndConditions),
    };
    if (editData?.id) payload.id = editData.id;

    setIsLoading(true);
    addData(url, payload)
      .then((response) => {
        setIsLoading(false);
        if (response?.data?.status === "success") {
          SuccesToast(response?.data?.message || "Saved Successfully");
          fetchHappyHours();
          handleClose();
        } else {
          ErrorToast(response?.data?.message || "Something went wrong");
        }
      })
      .catch((error) => {
        setIsLoading(false);
        console.error(error);
        ErrorToast("Something went wrong");
      });
  };

  const handleView = (row) => {
    setViewData(row);
    setShowView(true);
  };

  const handleDelete = (row) => {
    setRowDataToDelete(row);
    setShowDeleteModal(true);
  };

  const deleteHappyHour = () => {
    const id = rowDataToDelete.id;
    setIsLoading(true);
    deleteData(`${endPoints.api.DELETE_HAPPY_HOUR}${id}`)
      .then((response) => {
        setIsLoading(false);
        if (response.status === 200) {
          setShowDeleteModal(false);
          fetchHappyHours();
          SuccesToast("Deleted Successfully");
        }
      })
      .catch((error) => {
        console.error(error);
        setIsLoading(false);
      });
  };

  const playerTypeName = (id) => {
    const match = playerTypes.find((p) => p.id === id);
    return match ? match.player_type : id;
  };

  const handleFilterChange = (event) => {
    setFilterValue(event.target.value.toLowerCase());
    setPage(0);
  };

  const rowsToDisplay = rows.filter((item) =>
    filterValue.length > 0
      ? item?.title?.toLowerCase().includes(filterValue)
      : true
  );

  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rowsToDisplay.length) : 0;

  const handleChangePage = (event, newPage) => setPage(newPage);
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <>
      <div className="main">
        <Toaster></Toaster>
        <DeleteModel
          showModal={showDeleteModal}
          onClose={() => setShowDeleteModal(false)}
          onDelete={deleteHappyHour}
        />
        {isLoading && <Loader spinner={true} visible={isLoading} />}
        <div id="Sportbook" style={{ padding: "0px" }}>
          <div className="container-fluid bg-color-sportbook custom-card4">
            <div className="inner-space1">
              <PageHeader title="Happy Hours" crumb="Promotions / Happy Hours" />

              <div style={{ marginTop: "10px" }}>
                <div className="table_search" style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                  <TextField
                    style={{ marginBottom: "10px", width: "25%" }}
                    placeholder="Search by title..."
                    type="text"
                    onChange={handleFilterChange}
                    value={filterValue}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <SearchIcon />
                        </InputAdornment>
                      ),
                    }}
                  />
                </div>
                <div className="row">
                  <div className="col-md-12">
                    <TableContainer component={Paper}>
                      <Table className="c_table" size="small" stickyHeader sx={{ minWidth: 500 }} aria-label="happy hours table">
                        <TableHead>
                          <TableRow>
                            <TableCell align="center">ID</TableCell>
                            <TableCell align="center">Title</TableCell>
                            <TableCell align="center">Start</TableCell>
                            <TableCell align="center">Duration (min)</TableCell>
                            <TableCell align="center">Coin x</TableCell>
                            <TableCell align="center">Streak x</TableCell>
                            <TableCell align="center">Event Date</TableCell>
                            <TableCell align="center">Status</TableCell>
                            <TableCell align="center">Options</TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {rowsToDisplay
                            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                            .map((row) => (
                              <TableRow key={row.id} sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
                                <TableCell align="center">{row.id}</TableCell>
                                <TableCell align="center">{row.title}</TableCell>
                                <TableCell align="center">
                                  {row.startTime ? row.startTime.slice(0, 5) : "-"}
                                </TableCell>
                                <TableCell align="center">{row.durationMinutes}</TableCell>
                                <TableCell align="center">{row.coinMultiplier}x</TableCell>
                                <TableCell align="center">{row.streakMultiplier}x</TableCell>
                                <TableCell align="center">{row.eventDate || "Daily"}</TableCell>
                                <TableCell align="center">
                                  <Chip
                                    size="small"
                                    label={row.isActive === 1 ? "Active" : "Inactive"}
                                    color={row.isActive === 1 ? "success" : "default"}
                                  />
                                </TableCell>
                                <TableCell align="center">
                                  <VisibilityIcon style={{ cursor: "pointer" }} onClick={() => handleView(row)} />
                                  <EditIcon
                                    style={{ cursor: "pointer" }}
                                    onClick={() => {
                                      setShow(true);
                                      setEditData(row);
                                    }}
                                  />
                                  <DeleteIcon style={{ cursor: "pointer" }} onClick={() => handleDelete(row)} />
                                </TableCell>
                              </TableRow>
                            ))}

                          {emptyRows > 0 && (
                            <TableRow style={{ height: 53 * emptyRows }}>
                              <TableCell colSpan={9} />
                            </TableRow>
                          )}
                        </TableBody>
                        <TableFooter>
                          <TableRow>
                            <TablePagination
                              rowsPerPageOptions={[5, 10, 25, { label: "All", value: -1 }]}
                              colSpan={9}
                              count={rowsToDisplay.length}
                              rowsPerPage={rowsPerPage}
                              page={page}
                              SelectProps={{ inputProps: { "aria-label": "rows per page" }, native: true }}
                              onPageChange={handleChangePage}
                              onRowsPerPageChange={handleChangeRowsPerPage}
                              ActionsComponent={TablePaginationActions}
                            />
                          </TableRow>
                        </TableFooter>
                      </Table>
                    </TableContainer>
                  </div>

                  {/* Add / Edit Modal */}
                  <Modal show={show} onHide={handleClose} size="lg">
                    <Modal.Header closeButton>
                      <Modal.Title id="contained-modal-title-vcenter">
                        {editData?.id ? "Edit Happy Hour" : "Add Happy Hour"}
                      </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      <div className="row">
                        <div className="col-md-6">
                          <Form.Group className="mb-3" controlId="title">
                            <Form.Label>Title</Form.Label>
                            <Form.Control
                              type="text"
                              placeholder="e.g. Evening Happy Hour"
                              value={form.title}
                              onChange={(e) => setField("title", e.target.value)}
                            />
                          </Form.Group>
                        </div>
                        <div className="col-md-6">
                          <Form.Group className="mb-3" controlId="multiplier">
                            <Form.Label>Multiplier (display, e.g. 2)</Form.Label>
                            <Form.Control
                              type="number"
                              placeholder="2"
                              value={form.multiplier}
                              onChange={(e) => setField("multiplier", e.target.value)}
                            />
                          </Form.Group>
                        </div>
                        <div className="col-md-6">
                          <Form.Group className="mb-3" controlId="startTime">
                            <Form.Label>Start Time (ET)</Form.Label>
                            <Form.Control
                              type="time"
                              value={form.startTime}
                              onChange={(e) => setField("startTime", e.target.value)}
                            />
                          </Form.Group>
                        </div>
                        <div className="col-md-6">
                          <Form.Group className="mb-3" controlId="durationMinutes">
                            <Form.Label>Duration (minutes)</Form.Label>
                            <Form.Control
                              type="number"
                              placeholder="120"
                              value={form.durationMinutes}
                              onChange={(e) => setField("durationMinutes", e.target.value)}
                            />
                          </Form.Group>
                        </div>
                        <div className="col-md-6">
                          <Form.Group className="mb-3" controlId="eventDate">
                            <Form.Label>Event Date (optional, blank = daily)</Form.Label>
                            <Form.Control
                              type="date"
                              value={form.eventDate}
                              onChange={(e) => setField("eventDate", e.target.value)}
                            />
                          </Form.Group>
                        </div>
                        <div className="col-md-6">
                          <Form.Group className="mb-3" controlId="isActive">
                            <Form.Label>Status</Form.Label>
                            <Form.Select
                              value={form.isActive}
                              onChange={(e) => setField("isActive", e.target.value)}
                            >
                              <option value={1}>Active</option>
                              <option value={0}>Inactive</option>
                            </Form.Select>
                          </Form.Group>
                        </div>
                        <div className="col-md-6">
                          <Form.Group className="mb-3" controlId="coinMultiplier">
                            <Form.Label>Coin Multiplier</Form.Label>
                            <Form.Control
                              type="number"
                              placeholder="2"
                              value={form.coinMultiplier}
                              onChange={(e) => setField("coinMultiplier", e.target.value)}
                            />
                          </Form.Group>
                        </div>
                        <div className="col-md-6">
                          <Form.Group className="mb-3" controlId="streakMultiplier">
                            <Form.Label>Streak Multiplier</Form.Label>
                            <Form.Control
                              type="number"
                              placeholder="2"
                              value={form.streakMultiplier}
                              onChange={(e) => setField("streakMultiplier", e.target.value)}
                            />
                          </Form.Group>
                        </div>
                        <div className="col-md-6">
                          <Form.Group className="mb-3" controlId="bonusDrop">
                            <Form.Label>Bonus Drop</Form.Label>
                            <Form.Control
                              type="number"
                              placeholder="5000"
                              value={form.bonusDrop}
                              onChange={(e) => setField("bonusDrop", e.target.value)}
                            />
                          </Form.Group>
                        </div>
                        <div className="col-md-6">
                          <Form.Group className="mb-3" controlId="cashDrop">
                            <Form.Label>Cash Drop</Form.Label>
                            <Form.Control
                              type="number"
                              placeholder="5"
                              value={form.cashDrop}
                              onChange={(e) => setField("cashDrop", e.target.value)}
                            />
                          </Form.Group>
                        </div>
                        <div className="col-md-6">
                          <Form.Group className="mb-3" controlId="minPackage">
                            <Form.Label>Min Package ($)</Form.Label>
                            <Form.Control
                              type="number"
                              placeholder="10"
                              value={form.minPackage}
                              onChange={(e) => setField("minPackage", e.target.value)}
                            />
                          </Form.Group>
                        </div>
                        <div className="col-md-6">
                          <Form.Group className="mb-3" controlId="teaserLeadMinutes">
                            <Form.Label>Teaser Lead (minutes before)</Form.Label>
                            <Form.Control
                              type="number"
                              placeholder="60"
                              value={form.teaserLeadMinutes}
                              onChange={(e) => setField("teaserLeadMinutes", e.target.value)}
                            />
                          </Form.Group>
                        </div>
                        <div className="col-md-6">
                          <Form.Group className="mb-3" controlId="recapWindowMinutes">
                            <Form.Label>Recap Window (minutes after)</Form.Label>
                            <Form.Control
                              type="number"
                              placeholder="60"
                              value={form.recapWindowMinutes}
                              onChange={(e) => setField("recapWindowMinutes", e.target.value)}
                            />
                          </Form.Group>
                        </div>
                        <div className="col-md-12">
                          <Form.Group className="mb-3" controlId="excludePlayer">
                            <Form.Label>Exclude Player Types</Form.Label>
                            <FormControl fullWidth size="small">
                              <Select
                                multiple
                                displayEmpty
                                value={form.exclude_player}
                                onChange={(e) =>
                                  setField(
                                    "exclude_player",
                                    (typeof e.target.value === "string"
                                      ? e.target.value.split(",")
                                      : e.target.value
                                    ).map(Number)
                                  )
                                }
                                input={<OutlinedInput />}
                                renderValue={(selected) => {
                                  if (!selected || selected.length === 0) {
                                    return (
                                      <span style={{ color: "#8990b8" }}>
                                        Select player types to exclude
                                      </span>
                                    );
                                  }
                                  return (
                                    <div style={{ display: "flex", flexWrap: "wrap", gap: 6 }}>
                                      {selected.map((id) => {
                                        const p = playerTypes.find((x) => x.id === id);
                                        return (
                                          <Chip
                                            key={id}
                                            size="small"
                                            label={p ? p.player_type : id}
                                          />
                                        );
                                      })}
                                    </div>
                                  );
                                }}
                                MenuProps={{ PaperProps: { style: { maxHeight: 320 } }, sx: { zIndex: 1600 } }}
                              >
                                {playerTypes.map((p) => (
                                  <MenuItem key={p.id} value={p.id}>
                                    <Checkbox checked={form.exclude_player.includes(p.id)} />
                                    <ListItemText primary={p.player_type} />
                                  </MenuItem>
                                ))}
                              </Select>
                            </FormControl>
                          </Form.Group>
                        </div>
                        <div className="col-md-12">
                          <Form.Group className="mb-3" controlId="promotions">
                            <Form.Label>Promotions</Form.Label>
                            <FormControl fullWidth size="small">
                              <Select
                                multiple
                                displayEmpty
                                value={form.promotions}
                                onChange={(e) =>
                                  setField(
                                    "promotions",
                                    (typeof e.target.value === "string"
                                      ? e.target.value.split(",")
                                      : e.target.value
                                    ).map(Number)
                                  )
                                }
                                input={<OutlinedInput />}
                                renderValue={(selected) => {
                                  if (!selected || selected.length === 0) {
                                    return (
                                      <span style={{ color: "#8990b8" }}>
                                        Select promotions
                                      </span>
                                    );
                                  }
                                  return (
                                    <div style={{ display: "flex", flexWrap: "wrap", gap: 6 }}>
                                      {selected.map((id) => {
                                        const p = promotions.find((x) => x.id === id);
                                        return (
                                          <Chip
                                            key={id}
                                            size="small"
                                            label={p ? p.name : id}
                                          />
                                        );
                                      })}
                                    </div>
                                  );
                                }}
                                MenuProps={{ PaperProps: { style: { maxHeight: 320 } }, sx: { zIndex: 1600 } }}
                              >
                                {promotions.map((p) => (
                                  <MenuItem key={p.id} value={p.id}>
                                    <Checkbox checked={form.promotions.includes(p.id)} />
                                    <ListItemText primary={p.name} />
                                  </MenuItem>
                                ))}
                              </Select>
                            </FormControl>
                          </Form.Group>
                        </div>

                        {form.promotions.length > 0 && (
                          <div className="col-md-12">
                            <Form.Label>Promotion Coin Multipliers</Form.Label>
                            <div className="row">
                              {form.promotions.map((id) => {
                                const p = promotions.find((x) => x.id === id);
                                return (
                                  <div className="col-md-6 mb-3" key={id}>
                                    <Form.Group controlId={`promoMultiplier-${id}`}>
                                      <Form.Label style={{ fontSize: 13 }}>
                                        {p ? p.name : `Promotion #${id}`}
                                      </Form.Label>
                                      <Form.Control
                                        type="number"
                                        min="0"
                                        step="any"
                                        placeholder="Coin multiplier"
                                        value={form.promotionMultipliers?.[id] ?? ""}
                                        onChange={(e) =>
                                          setField("promotionMultipliers", {
                                            ...form.promotionMultipliers,
                                            [id]: e.target.value,
                                          })
                                        }
                                      />
                                    </Form.Group>
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                        )}

                        <div className="col-md-12">
                          <Form.Group className="mb-3" controlId="specifications">
                            <Form.Label>Specifications</Form.Label>
                            <Form.Control
                              as="textarea"
                              rows={2}
                              value={form.specifications}
                              onChange={(e) => setField("specifications", e.target.value)}
                            />
                          </Form.Group>
                        </div>
                        <div className="col-md-12">
                          <Form.Group className="mb-3" controlId="termsAndConditions">
                            <Form.Label>Terms &amp; Conditions</Form.Label>
                            <Form.Control
                              as="textarea"
                              rows={2}
                              value={form.termsAndConditions}
                              onChange={(e) => setField("termsAndConditions", e.target.value)}
                            />
                          </Form.Group>
                        </div>

                        {/* Per-language content lives in its own popup. */}
                        <div className="col-md-12">
                          <div
                            style={{
                              borderTop: "1px solid #2A3056",
                              marginTop: "4px",
                              paddingTop: "12px",
                            }}
                          >
                            <Button
                              variant="primary"
                              style={{ background: "#0D3862", borderRadius: "8px" }}
                              onClick={() => setShowTranslations(true)}
                            >
                              Translations
                            </Button>
                          </div>
                        </div>
                      </div>
                    </Modal.Body>
                    <Modal.Footer>
                      <Button onClick={handleOk} style={{ background: "#04631e", borderColor: "#04631e" }}>
                        Apply
                      </Button>
                    </Modal.Footer>
                  </Modal>

                  {/* Translations popup — fields are kept in state and saved with Apply on the main form. */}
                  <Modal
                    show={showTranslations}
                    onHide={() => setShowTranslations(false)}
                    size="lg"
                    backdrop="static"
                    keyboard={false}
                  >
                    <Modal.Header closeButton>
                      <Modal.Title style={{ fontSize: "20px" }}>Translations</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      <div style={{ fontSize: "12px", color: "#8990B8", marginBottom: "12px" }}>
                        Optional. Languages left blank fall back to the English text above.
                      </div>
                      <div className="row">
                        {/* English edits the base fields of the main form. */}
                        <div className="col-md-6">
                          <div
                            style={{
                              border: "1px solid #2A3056",
                              borderRadius: "10px",
                              padding: "12px",
                              marginBottom: "12px",
                            }}
                          >
                            <div style={{ fontWeight: 600, marginBottom: "8px" }}>
                              🇺🇸 English <span style={{ color: "#8990B8", fontWeight: 400 }}>(base)</span>
                            </div>
                            <Form.Group className="mb-2" controlId="title-en">
                              <Form.Label>Title</Form.Label>
                              <Form.Control
                                type="text"
                                value={form.title}
                                onChange={(e) => setField("title", e.target.value)}
                              />
                            </Form.Group>
                            <Form.Group className="mb-2" controlId="specifications-en">
                              <Form.Label>Specifications</Form.Label>
                              <Form.Control
                                as="textarea"
                                rows={2}
                                value={form.specifications}
                                onChange={(e) => setField("specifications", e.target.value)}
                              />
                            </Form.Group>
                            <Form.Group className="mb-1" controlId="termsAndConditions-en">
                              <Form.Label>Terms &amp; Conditions</Form.Label>
                              <Form.Control
                                as="textarea"
                                rows={2}
                                value={form.termsAndConditions}
                                onChange={(e) => setField("termsAndConditions", e.target.value)}
                              />
                            </Form.Group>
                          </div>
                        </div>
                        {LANGS.map((lang) => (
                          <div className="col-md-6" key={lang.code}>
                            <div
                              style={{
                                border: "1px solid #2A3056",
                                borderRadius: "10px",
                                padding: "12px",
                                marginBottom: "12px",
                              }}
                            >
                              <div style={{ fontWeight: 600, marginBottom: "8px" }}>
                                {lang.flag} {lang.name}
                              </div>
                              <Form.Group className="mb-2" controlId={`title-${lang.code}`}>
                                <Form.Label>Title</Form.Label>
                                <Form.Control
                                  type="text"
                                  value={translations[lang.code]?.title || ""}
                                  onChange={(e) => setTranslationField(lang.code, "title", e.target.value)}
                                />
                              </Form.Group>
                              <Form.Group className="mb-2" controlId={`specifications-${lang.code}`}>
                                <Form.Label>Specifications</Form.Label>
                                <Form.Control
                                  as="textarea"
                                  rows={2}
                                  value={translations[lang.code]?.specifications || ""}
                                  onChange={(e) => setTranslationField(lang.code, "specifications", e.target.value)}
                                />
                              </Form.Group>
                              <Form.Group className="mb-1" controlId={`termsAndConditions-${lang.code}`}>
                                <Form.Label>Terms &amp; Conditions</Form.Label>
                                <Form.Control
                                  as="textarea"
                                  rows={2}
                                  value={translations[lang.code]?.termsAndConditions || ""}
                                  onChange={(e) => setTranslationField(lang.code, "termsAndConditions", e.target.value)}
                                />
                              </Form.Group>
                            </div>
                          </div>
                        ))}
                      </div>
                    </Modal.Body>
                    <Modal.Footer>
                      <Button
                        onClick={() => setShowTranslations(false)}
                        style={{ background: "#04631e", borderColor: "#04631e" }}
                      >
                        Done
                      </Button>
                    </Modal.Footer>
                  </Modal>

                  {/* Detail (View) Modal */}
                  <Modal show={showView} onHide={() => setShowView(false)} size="lg">
                    <Modal.Header closeButton>
                      <Modal.Title>Happy Hour Details</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      {viewData && (
                        <div className="row">
                          <div className="col-md-6 mb-3"><strong>ID:</strong> {viewData.id}</div>
                          <div className="col-md-6 mb-3"><strong>Title:</strong> {viewData.title}</div>
                          <div className="col-md-6 mb-3"><strong>Multiplier:</strong> {viewData.multiplier}x</div>
                          <div className="col-md-6 mb-3"><strong>Start Time:</strong> {viewData.startTime}</div>
                          <div className="col-md-6 mb-3"><strong>Duration:</strong> {viewData.durationMinutes} min</div>
                          <div className="col-md-6 mb-3"><strong>Event Date:</strong> {viewData.eventDate || "Daily"}</div>
                          <div className="col-md-6 mb-3"><strong>Coin Multiplier:</strong> {viewData.coinMultiplier}x</div>
                          <div className="col-md-6 mb-3"><strong>Streak Multiplier:</strong> {viewData.streakMultiplier}x</div>
                          <div className="col-md-6 mb-3"><strong>Bonus Drop:</strong> {viewData.bonusDrop}</div>
                          <div className="col-md-6 mb-3"><strong>Cash Drop:</strong> {viewData.cashDrop}</div>
                          <div className="col-md-6 mb-3"><strong>Min Package:</strong> {viewData.minPackage ?? "—"}</div>
                          <div className="col-md-6 mb-3"><strong>Teaser Lead:</strong> {viewData.teaserLeadMinutes} min</div>
                          <div className="col-md-6 mb-3"><strong>Recap Window:</strong> {viewData.recapWindowMinutes} min</div>
                          <div className="col-md-6 mb-3">
                            <strong>Status:</strong> {viewData.isActive === 1 ? "Active" : "Inactive"}
                          </div>
                          <div className="col-md-12 mb-3">
                            <strong>Excluded Player Types:</strong>{" "}
                            {Array.isArray(viewData.exclude_player) && viewData.exclude_player.length > 0
                              ? viewData.exclude_player.map(playerTypeName).join(", ")
                              : "None"}
                          </div>
                          <div className="col-md-12 mb-3">
                            <strong>Promotions:</strong>{" "}
                            {Array.isArray(viewData.promotions) && viewData.promotions.length > 0
                              ? viewData.promotions
                                  .map((p) => {
                                    const id = typeof p === "object" ? p.id : p;
                                    const mult = typeof p === "object" ? p.coinMultiplier : undefined;
                                    const promo = promotions.find((x) => x.id === id);
                                    const name = promo ? promo.name : `#${id}`;
                                    return mult != null && mult !== "" ? `${name} (${mult}x)` : name;
                                  })
                                  .join(", ")
                              : "None"}
                          </div>
                          <div className="col-md-12 mb-3">
                            <strong>Specifications:</strong> {viewData.specifications || "-"}
                          </div>
                          <div className="col-md-12 mb-3">
                            <strong>Terms &amp; Conditions:</strong> {viewData.termsAndConditions || "-"}
                          </div>
                        </div>
                      )}
                    </Modal.Body>
                    <Modal.Footer>
                      <Button onClick={() => setShowView(false)} style={{ background: "#04631e", borderColor: "#04631e" }}>
                        Close
                      </Button>
                    </Modal.Footer>
                  </Modal>
                </div>
              </div>

              <div style={{ display: "flex", justifyContent: "end", marginTop: "20px" }}>
                <Button
                  variant="primary"
                  style={{ background: "#04631e", borderColor: "#04631e" }}
                  onClick={() => {
                    setShow(true);
                    setEditData({});
                  }}
                >
                  Add New Happy Hour
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default HappyHour;
